import React from 'react';
import cx from 'classnames';

import styles from './Select.module.scss';

const Select = ({
  children,
  label,
  onChange,
  required = false,
  error = false,
  value,
  defaultValue = '',
  ...props
}) => {
  const [hasValue, setHasValue] = React.useState(defaultValue || value);

  const handleChange = React.useCallback(
    (event) => {
      setHasValue(event.currentTarget.value);
      onChange(event);
    },
    [],
  );

  const className = cx({
    [styles.root]: true,
    [styles.error]: error,
    [styles.hasValue]: hasValue,
  });

  return (
    <div className={className}>
      <label>
        <span className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </span>
        <select
          {...props}
          className={styles.input}
          onChange={handleChange}
          defaultValue={defaultValue}
        >
          {!hasValue && <option disabled value=""></option>}
          {children}
        </select>
      </label>
    </div>
  );
}
export default Select;
